module.exports = __webpack_public_path__ + "static/control-panel-image-6469936e7a86111175ec174ba95c6305.svg";